"use strict";
// Date Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#date-expression-operators
Object.defineProperty(exports, "__esModule", { value: true });
exports.$dateFromParts = void 0;
var core_1 = require("../../../core");
var _internal_1 = require("./_internal");
/**
 * Constructs and returns a Date object given the date’s constituent properties.
 *
 * @param obj The document
 * @param expr The date expression
 * @param options Options
 */
function $dateFromParts(obj, expr, options) {
    var args = (0, core_1.computeValue)(obj, expr, null, options);
    var tz = (0, _internal_1.parseTimezone)(args.timezone);
    // assign default and adjust value ranges of the different parts
    for (var i = _internal_1.DATE_PART_INTERVAL.length - 1, remainder = 0; i >= 0; i--) {
        var datePartInterval = _internal_1.DATE_PART_INTERVAL[i];
        var k = datePartInterval[0];
        var min = datePartInterval[1];
        var max = datePartInterval[2];
        // add remainder from previous part. units should already be correct
        var part = (args[k] || 0) + remainder;
        // 1. compute the remainder for the next part
        // 2. adjust the current part to a valid range
        // 3. assign back to 'args'
        var limit = max + 1;
        // invert timezone to adjust the hours to UTC
        if (k == "hour")
            part += tz.hour * -1;
        if (k == "minute")
            part += tz.minute * -1;
        // smaller than lower bound
        if (part < min) {
            var delta = min - part;
            remainder = -1 * Math.ceil(delta / limit);
            part = limit - (delta % limit);
        }
        else if (part > max) {
            // offset with the 'min' value to adjust non-zero date parts correctly
            part += min;
            remainder = Math.trunc(part / limit);
            part %= limit;
        }
        // reassign
        args[k] = part;
    }
    return new Date(Date.UTC(args.year, args.month - 1, args.day, args.hour, args.minute, args.second, args.millisecond));
}
exports.$dateFromParts = $dateFromParts;
